import { render, staticRenderFns } from "./EventTabGeneralInformation.vue?vue&type=template&id=58ff6a40&"
import script from "./EventTabGeneralInformation.vue?vue&type=script&lang=js&"
export * from "./EventTabGeneralInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports